module.exports = __webpack_public_path__ + "assets/img/17_1088_big.07b506fb.jpg";